import { useEffect, useState } from "react";
import InlineSVG from "react-inlinesvg";
import { Switch, Route, useRouteMatch, Link } from "react-router-dom";
import WorkflowList from "./WorkflowList";
import WorkflowDetail from "./WorkflowDetail";

import { useWorkflowStore } from "./workflowStore";
import Auth from "src/Auth";

function Workflows() {
  const { path } = useRouteMatch();
  const setWorkflows = useWorkflowStore((state) => state.setWorkflows);
  const getAvailableEngines = useWorkflowStore((state) => state.getAvailableEngines);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWorkflows = async () => {
      const result = await Auth.fetchWithIdToken("/api/workflows/all");
      setWorkflows(result.workflows);
      setLoading(false);
    };
    setLoading(true);
    fetchWorkflows();
  }, [setWorkflows]);

  useEffect(() => {
    getAvailableEngines();
  }, [getAvailableEngines]);

  return (
    <div className="flex flex-col items-start space-y-4 m-4 p-2 bg-white justify-start text-left">
      <div className="flex flex-row items-center justify-start">
        <h1 className="text-2xl font-bold mb-0">
          <Link
            to="/ai-functions"
            className="hover:text-blue-600 text-black"
          >
            AI Functions
          </Link>
        </h1>
      </div>
      {loading && (
        <div className="flex justify-start items-center h-full">
          <div className="animate-spin">
            <InlineSVG
              src="/assets/loader.svg"
              className="w-10 h-10"
            />
          </div>
        </div>
      )}
      {!loading && (
        <Switch>
          <Route
            exact
            path={path}
          >
            <WorkflowList />
          </Route>
          <Route path={`${path}/:workflowId/v/:versionId`}>
            <WorkflowDetail />
          </Route>
          <Route path={`${path}/:workflowId`}>
            <WorkflowDetail />
          </Route>
        </Switch>
      )}
    </div>
  );
}

export default Workflows;
